import {
  ActionIcon,
  Box,
  createStyles,
  ScrollArea,
  Text,
  Table,
  Button,
  Center,
  Menu,
  Group,
} from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { FaEye } from "react-icons/fa6";
import { BiExport } from "react-icons/bi";
import { RiFilter3Line } from "react-icons/ri";
import { getAllBillingModal, removeBilling } from "../../services";
import { useSelector } from "react-redux";
import EditBilling from "./EditBilling";
import swal from "sweetalert";
import TableLoader from "../TableLoader";
import ClaimFilter from "./ClaimFilter";
import BillingSearchAll from "../Document/BilllingSearchAll";
import CustomBillingPagination from "../Pagination/CustomBillingPagination";
import RecordNotFound from "../RecordNotFound";
import moment from "moment-timezone";
import BillingHistory from "./BillingHistory";

// import RecordNotFound from "../../../RecordNotFound";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      backgroundColor: "#F2F2F2",
      color: "#000 !important",
    },
    "& th:first-of-type": {
      borderTopLeftRadius: "16px !important",
      borderBottomLeftRadius: "16px !important",
    },
    "& th:last-of-type": {
      borderTopRightRadius: "16px !important",
      borderBottomRightRadius: "16px !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },

  item: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    marginBottom: "8px",
    overflow: "hidden",
    background: "#fff",
    padding: "0px",
  },

  clientInfoCardDataParent: {
    display: "flex",
    justifyContent: "space-between !important",
    gap: "73px",
    "@media (max-width:1200px)": {
      gap: "10px",
    },
  },

  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    justifyContent: "center",
  },

  searchbox: {
    // marginTop: "20px",
    // marginBottom: "20px",
    width: "30%",
    padding: "none !important",
    border: "none !important",

    "@media (max-width:1200px)": {
      width: "100%",
    },
    // marginTop: "50px",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  newrow: {
    margin: "auto",
    //  width: "30%",
    display: "flex",
    justifyContent: "center",

    "@media (max-width:1300px)": {
      width: "55%",
    },
    "@media (max-width:500px)": {
      width: "95%",
    },
  },

  flex: {
    display: "flex",
    justifyContent: "space-between",

    "@media (max-width:1200px)": {
      gap: "10px",
      flexDirection: "column",
      alignItems: "center",
    },
  },

  mainaccord: {
    width: "100%",
    // padding: "14px 12px",
    // background: "#F9FAFB",
  },

  accordionbox: {
    display: "flex",
    alignItems: "center",
    // justifyContent: "space-between",
    // padding: "14px 12px",
    // background: "#F9FAFB",
    gap: "4px",
  },

  gap: {
    display: "flex",
    gap: "20px",
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
    borderRadius: "15px",
  },
  tableHeader: {
    borderBottom: "none !important",
  },
  accordionExpandedContent: {
    minHeight: "auto",
    maxHeight: "250px",
    overflowY: "auto",
  },
  button: {
    "&:hover": {
      background: "#FFAF4A",
      color: "#000",
      opacity: 0.8,
    },
  },

  exportbutton: {
    "&:hover": {
      background: "grey",
      color: "#000",
      opacity: 0.8,
    },
  },

  tablenewHeader: {
    color: "#000 !important",
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
  },

  tablenewRow: {
    color: "#000 !important",
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
  },

  rejected: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#FEF3F2",
  },

  accepted: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#ECFDF3",
  },

  acknowledged: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#F9F5FF",
  },

    pending: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#F4E04D",
  },



  

  previousclaims: {
    background: "#FFF",
    padding: "12px 8px",
    width: "98%",
    borderRadius: "16px",
    marginBottom: "20px",
  },

  textbox: {
    marginTop: "29px",
    marginBottom: "7px",
    alignSelf: "flex-start",
    marginLeft: "20px",
  },
}));

function PreviousClaims({
  setClaimDetails,
  decryptedBillingData,
  setDecryptedBillingData,
}) {
  const { classes, cx } = useStyles();
  const [scrolled, setScrolled] = useState(false);
  const { allBilling, loading } = useSelector((state) => state?.billing);

  const [filtermodal, setFilterModal] = useState(false);

  const [editbilling, SetEditbilling] = useState(false);
  const [billinghistory, SetBillinghistory] = useState(false);

  const [billing, setbilling] = useState({ id: null, claim: null });

  const [view, setView] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [billingsearch, setBillingSearch] = useState("");

  // console.log("allBilling", allBilling);

  // console.log('billingsearch',billingsearch);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // useEffect(() => {
  //   if (allBilling?.Billing) {
  //     const decryptedData = allBilling.Billing.map((billing) => {
  //       return {
  //         ...billing,
  //         billingForm: decrypt(billing.billingForm),
  //       };
  //     });
  //     setDecryptedBillingData(decryptedData);
  //   }
  // }, [allBilling]);

  useEffect(() => {
    getAllBillingModal({ page: currentPage });
  }, [currentPage]);

  // edit

  const openEditModal = (id, claim) => {
    ///console.log('check item',claim);
    setView(false);
    setbilling({ id, claim });
    SetEditbilling(true);
  };

  // view

  const openViewModal = (id, claim) => {
    setbilling({ id, claim });
    setView(true);
    SetEditbilling(true);
  };

  // history

  const openHistoryModal = (id, claim) => {
    setbilling({ id, claim });
    SetBillinghistory(true);
  };


  // remove
  const remove = async (id, claimid) => {
    // console.log('id',id);

    // console.log('claimid',claimid);

    let payload = {
      id,
      claimid,
    };

    console.log("payload", payload);

    // event.stopPropagation();
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removeBilling(payload);
  };

  // view billing info
  const handleIconClick = (billingItem) => {
    setDecryptedBillingData(billingItem);
    setClaimDetails(true);
  };

  const SearchBilling = async (searchValue) => {
    let paylaod = {
      name: billingsearch,
    };

    console.log("API Call: Search for ", billingsearch);

    try {
      await getAllBillingModal(paylaod);
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  const allbilling = loading ? (
    <TableLoader />
  ) : (
    <ScrollArea
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      sx={{ minHeight: "300px" }}
    >
      <Table
        highlightOnHover={true}
        enableStickyHeader={true}
        sx={{
          fontFamily: "Inter",
          borderRadius: "5px",
          border: "1px solid #E5E5E5",
          marginTop: "20px",
        }}
        fontSize={"sm"}
        verticalSpacing={"md"}
      >
        <thead>
          <tr>
            <th></th>
            <th>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Payer Name
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Provider Name
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Provider Type
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Payer ID
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                No Of Clients
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Claim ID
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Submission Date
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Claim Total Amount
              </Text>
            </th>
            <th className={classes.header}></th>
          </tr>
        </thead>
        <tbody>
          {allBilling?.Billing?.length > 0 ? (
            allBilling?.Billing?.filter((item) =>
              item?.billingForm?.claim?.some((claim) => claim.deleted !== true)
            )?.map((item, index) => {
              const bg = index % 2 === 0 ? classes.bg2 : classes.bg1;

              return (
                <tr
                  style={{ cursor: "pointer" }}
                  onClick={() => handleIconClick(item)}
                  key={item?.id}
                  className={bg}
                >
                  <td></td>
                  <td>
                    <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
                      {item?.billingForm?.claim[0]?.payer_name}
                    </Text>
                  </td>
                  <td>
                    <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
                      {item?.billingForm?.claim[0]?.prov_name_m}
                    </Text>
                  </td>
                  <td>
                    <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
                      {item?.billingForm?.claim[0]?.prov_name_m}
                    </Text>
                  </td>
                  <td>
                    <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
                      {item?.billingForm?.claim[0]?.payerid}
                    </Text>
                  </td>
                  <td>
                    <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
                      {item?.billingForm?.claim?.length}
                    </Text>
                  </td>
                  <td>
                    <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
                      {/* {item?.billingForm?.claim[0]?.claim_form === "837p"
                        ? "Professional"
                        : "Institutional"} */}
                      {item?.billingForm?.claim[0]?.claimmd_id}
                    </Text>
                  </td>
                  <td>
                    <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
                      {item?.createdAt
                        ? new Date(item?.createdAt).toLocaleDateString("en-US")
                        : "Date Not Available"}
                    </Text>
                  </td>
                  <td>
                    {/* -----> Latest Code <----- */}
                    <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
                      $
                      {item?.billingForm?.claim?.length > 0
                        ? item?.billingForm?.claim
                            ?.flatMap((claim) => claim.charge)
                            ?.reduce((total, chargeItem) => {
                              const charge =
                                parseFloat(chargeItem?.charge) || 0;
                              return total + charge;
                            }, 0)
                            // .toFixed(2)
                            .toLocaleString("en-US")
                        : "N/A"}
                    </Text>
                  </td>

                  <td>
                    <img
                      width={20}
                      src="/assets/images/claimsiconsview.png"
                      alt="check-icon"
                      onClick={() => handleIconClick(item)}
                    />
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={1000}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    height: "55vh",
                    gap: "8rem",
                  }}
                >
                  <RecordNotFound />
                  <Center>
                    <p className={classes.notFoundText}>
                      You don&apos;t have any record, Add Billing
                    </p>
                  </Center>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <Center>
        <CustomBillingPagination
          data={allBilling?.count}
          itemsPerPage={10}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </Center>
    </ScrollArea>
  );

  // console.log('decryptedBillingData?.billingForm?.claim?.length',decryptedBillingData?.billingForm?.claim?.length);

  const BillingInfoTable = ({
    decryptedBillingData,
    setDecryptedBillingData,
  }) => {
    // console.log('decryptedBillingData',decryptedBillingData);

    return (
      <ScrollArea
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
        sx={{ minHeight: "550px" }}
      >
        <Table
          highlightOnHover={true}
          enableStickyHeader={true}
          sx={{
            fontFamily: "Inter",
            borderRadius: "5px",
            border: "1px solid #E5E5E5",
          }}
          fontSize={"sm"}
          verticalSpacing={"md"}
        >
          <thead>
            <tr>
              <th className={classes.tablenewHeader}>Status</th>
              <th className={classes.tablenewHeader}>Client Name</th>
              <th className={classes.tablenewHeader}>Claim ID</th>
              <th className={classes.tablenewHeader}>From Date</th>
              <th className={classes.tablenewHeader}>To Date</th>
              <th className={classes.tablenewHeader}>Total Charge</th>
              <th className={classes.tablenewHeader}>Action</th>
            </tr>
          </thead>
          <tbody>
            {decryptedBillingData?.billingForm?.claim?.length > 0 ||
            undefined ? (
              decryptedBillingData.billingForm.claim.map(
                (claim, claimIndex) => {
                  // console.log("claim", claim);

                  const bg = claimIndex % 2 === 0 ? classes.bg2 : classes.bg1;
                  return (
                    <tr className={bg} key={claimIndex}>
                      <td>
                        <Box
                          // className={
                          //   claim?.status === "R"
                          //     ? classes.rejected
                          //     : classes.accepted
                          // }
                          className={
                            claim?.status === "R"
                              ? classes.rejected
                              : claim?.status === "A"
                              ? classes.acknowledged
                              : claim?.status === "pending"
                              ? classes.pending
                              :classes.accepted
                          }
                        >
                          <Text
                            ta={"center"}
                            fs={12}
                            fw={500}
                            
                            style={{ width: "max-content", margin:'auto', }}
                            // color={
                            //   claim?.status === "R" ? "#B42318" : "#027A48"
                            // }
                            // color={
                            //   claim?.status === "R"
                            //     ? "#B42318"
                            //     : claim?.status === "A"
                            //     ? "#6941C6"
                            //     : "#027A48"
                            // }
                            color={
                              claim?.status === "R"
                                ? "#B42318"
                                : claim?.status === "A"
                                ? "#6941C6"
                                : claim?.status === "P"
                                ? "#027A48"
                                : claim?.status === "pending"
                                ? "#000"
                                : "#344054"
                            }
                          >
                            <span
                              style={{
                                display: "inline-block",
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                               

                                backgroundColor:
                                  // claim?.status === "R"
                                  //   ? "#B42318"
                                  //   : "#027A48",
                                  // claim?.status === "R"
                                  //   ? "#B42318"
                                  //   : claim?.status === "A"
                                  //   ? "#9E77ED"
                                  //   : "#027A48",

                                  claim?.status === "R"
                                    ? "#B42318"
                                    : claim?.status === "A"
                                    ? "#9E77ED" // light green
                                    : claim?.status === "pending"
                                    ? "#000"
                                    : "#027A48",
                                marginRight: "5px",
                                verticalAlign: "middle",
                              }}
                            ></span>

                            {/* {claim?.status === "R" ? "Rejected" : "Accepted"} */}
                            {/* {claim?.status === "R"
                              ? "Rejected"
                              : claim?.status === "A"
                              ? "Pending"
                              : "Paid"} */}
                            {claim?.status === "R"
                              ? "Rejected"
                              : claim?.status === "A"
                              ? "Acknowledged"
                              : claim?.status === "P"
                              ? "Paid"
                              : "Pending"}
                          </Text>
                        </Box>
                      </td>
                      <td className={classes.tablenewRow}>
                        {claim.pat_name_f} {claim.pat_name_l}
                      </td>
                      <td className={classes.tablenewRow}>
                        {claim?.claimmd_id}
                      </td>
                      {/* <td className={classes.tablenewRow}>
                        {decryptedBillingData?.createdAt
                          ? new Date(
                              decryptedBillingData?.createdAt
                            ).toLocaleDateString("en-US")
                          : "Date Not Available"}
                      </td> */}
                      {/* <td className={classes.tablenewRow}>
                        {claim?.charge[0]?.from_date
                          ? moment(claim.charge[0].from_date).format(
                              "MM/DD/YYYY"
                            )
                          : 
                          
                          "Date Not Available"
                          
                          }
                      </td> */}

                      <td className={classes.tablenewRow}>
                        {claim?.charge?.length > 0
                          ? moment
                              .min(
                                claim.charge
                                  .filter((item) => item.from_date)
                                  .map((item) =>
                                    moment.tz(
                                      item.from_date,
                                      "YYYY-MM-DD",
                                      moment.tz.guess()
                                    )
                                  )
                              )
                              .format("MM/DD/YYYY")
                          : "Date Not Available"}
                      </td>

                      {/* <td className={classes.tablenewRow}>
                        {decryptedBillingData?.createdAt
                          ? new Date(
                              decryptedBillingData?.createdAt
                            ).toLocaleDateString("en-US")
                          : "Date Not Available"}
                      </td> */}
                      {/* <td className={classes.tablenewRow}>
                        {claim?.charge?.length
                          ? moment(
                              claim.charge[claim.charge.length - 1].thru_date
                            ).format("MM/DD/YYYY")
                          : "Date Not Available"}
                      </td> */}
                      <td className={classes.tablenewRow}>
                        {claim?.charge?.length > 0
                          ? moment
                              .max(
                                claim.charge
                                  .filter((item) => item.thru_date)
                                  .map((item) =>
                                    moment.tz(
                                      item.thru_date,
                                      "YYYY-MM-DD",
                                      moment.tz.guess()
                                    )
                                  )
                              )
                              .format("MM/DD/YYYY")
                          : "Date Not Available"}
                      </td>

                      {/* <td className={classes.tablenewRow}>
                        $
                        {claim?.charge &&
                        Array.isArray(claim?.charge) &&
                        claim?.charge?.length > 0
                          ? claim?.charge
                              ?.reduce((total, item) => total + item.charge, 0)
                              ?.toFixed(2)
                          : "N/A"}
                      </td> */}
                      <td className={classes.tablenewRow}>
                        ${claim?.total_charge?.toLocaleString("en-US") || "N/A"}
                        {/* {claim?.charge &&
                        Array.isArray(claim?.charge) &&
                        claim?.charge.length > 0
                          ? claim?.charge
                              ?.filter((item) => !isNaN(item.charge))
                              ?.reduce((total, item) => total + item.charge, 0)
                          : // ?.toFixed(2)
                            "N/A"} */}
                      </td>

                      <td>
                        <Group>
                          <Menu shadow="md" position="left" zIndex={"1000"}>
                            <Menu.Target>
                              <ActionIcon>
                                <BiDotsVerticalRounded
                                  id="vertical-dots"
                                  size={20}
                                  color="#000"
                                />
                              </ActionIcon>
                            </Menu.Target>
                            <Menu.Dropdown>
                              <Menu.Item
                                onClick={() =>
                                  openViewModal(decryptedBillingData._id, claim)
                                }
                                id="open-link"
                                icon={<FaEye size={14} />}
                              >
                                View
                              </Menu.Item>

                              {claim?.status === "R" ? (
                                <Menu.Item
                                  onClick={() =>
                                    openEditModal(
                                      decryptedBillingData._id,
                                      claim
                                    )
                                  }
                                  icon={<IconEdit size={14} />}
                                >
                                  Re-Submit
                                </Menu.Item>
                              ) : null}

      <Menu.Item
                                  onClick={() =>
                                    openHistoryModal(
                                      decryptedBillingData._id,
                                      claim
                                    )
                                  }
                                  icon={<IconEdit size={14} />}
                                >
                                  Claim History
                                </Menu.Item>

                            </Menu.Dropdown>
                          </Menu>
                        </Group>
                      </td>
                    </tr>
                  );
                }
              )
            ) : (
              <>
                <tr>
                  <td colSpan={1000}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                        height: "75vh",
                        gap: "8rem",
                      }}
                    >
                      <RecordNotFound />
                      <p className={classes.notFoundText}>
                        You don&apos;t have any record, Add Medications in
                        Individual to see here.
                      </p>
                    </div>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </Table>

        <Center>
          <CustomBillingPagination
            data={decryptedBillingData?.billingForm?.claim?.length}
            itemsPerPage={10}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        </Center>

        <EditBilling
          editbilling={editbilling}
          SetEditbilling={SetEditbilling}
          billing={billing}
          view={view}
          setDecryptedBillingData={setDecryptedBillingData}
        />

<BillingHistory
    billinghistory={billinghistory}
          SetBillinghistory={SetBillinghistory}
          billing={billing}


/>
        
      </ScrollArea>
    );
  };

  return (
    <>
      <Box className={classes.previousclaims}>
        <Box className={classes.flex}>
          <Box className={classes.searchbox}>
            <BillingSearchAll
              placeholder="Search Payer ID, Provider name, Payer name"
              onChange={SearchBilling}
              value={billingsearch}
              setValue={setBillingSearch}
            />
          </Box>

          <Box className={classes.gap}>
            <Button
              // className={classes.exportbutton}
              onClick={() => {
                setFilterModal(true);
              }}
              variant="fixed"
              c={"#000"}
              bg={"#F9FAFB"}
              radius="md"
              size="md"
            >
              <RiFilter3Line size={20} color="#000" variant="default" />
              Filter
            </Button>

            {/* {decryptedBillingData === null ? (
              <Button
                className={classes.button}
                variant="filled"
                c={"#000"}
                bg={"#FFAF4A"}
                radius="md"
                size="md"
              >
                Export
                <BiExport size={20} color="#000" variant="default" />
              </Button>
            ) : null} */}
          </Box>
        </Box>

        {decryptedBillingData === null ? <Box>{allbilling}</Box> : null}
      </Box>

      {decryptedBillingData !== null ? (
        <>
          <Box className={classes.textbox}>
            <Text ff={"Inter"} fz={"16px"} fw={"700"} color={"#000"}>
              {decryptedBillingData.billingForm.claim[0].prov_name_m}
            </Text>
          </Box>

          <Box className={classes.previousclaims}>
            <BillingInfoTable
              decryptedBillingData={decryptedBillingData}
              setDecryptedBillingData={setDecryptedBillingData}
            />
          </Box>
        </>
      ) : null}

      <ClaimFilter filtermodal={filtermodal} setFilterModal={setFilterModal} />
    </>
  );
}

export default PreviousClaims;
